
// (function () {
//   function applySafariSafeVideoAttrs(video, { withControls = false, muted = true } = {}) {
//     if (!video) return;

//     video.muted = muted;
//     video.loop = !withControls;
//     video.controls = withControls;
//     // Ensure the DOM attribute matches the property so Safari doesn't render
//     // native controls momentarily.
//     if (withControls) video.setAttribute('controls', '');
//     else video.removeAttribute('controls');
//     video.playsInline = true;
//     video.disablePictureInPicture = true;
//     video.setAttribute('playsinline', '');
//     video.setAttribute('webkit-playsinline', '');
//     video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
//     video.setAttribute('x-webkit-airplay', 'deny');
//     video.setAttribute('disablepictureinpicture', '');
//     video.removeAttribute('autopictureinpicture');
//   }

//   /* --------------- helpers --------------- */
//   function playActiveVideo(container, swiper) {
//     container.querySelectorAll('video').forEach(v => v.pause());

//     const activeSlide = swiper?.slides?.[swiper.activeIndex];
//     if (!activeSlide) return;

//     const video = activeSlide.querySelector('video');
//     if (!video) return;

//     applySafariSafeVideoAttrs(video, { withControls: false, muted: true });
//     video.currentTime = 0;
//     video.play().catch(() => {});

//     container.querySelectorAll('.swiper-slide')
//       .forEach(s => s.classList.remove('playing'));

//     activeSlide.classList.add('playing');
//   }

//   function buildDots(root, swiper) {

//   let wrap = root.querySelector('.video-slider--dots');

//   if (!wrap) {
//     wrap = document.createElement('div');
//     wrap.className = 'video-slider--dots';
//     root.appendChild(wrap);
//   }

//   wrap.innerHTML = '';

//   const realSlides = swiper.slides.filter(
//     sl => !sl.classList.contains('swiper-slide-duplicate')
//   );

//   const currentSlidesPerView = swiper.params.slidesPerView;

//   if (realSlides.length <= currentSlidesPerView) {
//     wrap.style.display = 'none';
//     return;
//   }

//   wrap.style.display = 'flex';

//   const numPages = realSlides.length;

//   for (let i = 0; i < numPages; i++) {

//     const dot = document.createElement('button');
//     dot.className = 'video-slider--dot';

//     dot.addEventListener('click', () => {
//       swiper.slideToLoop(i, 300); // ✅ loop fix
//     });

//     wrap.appendChild(dot);
//   }

//   const update = () => {

//     const active = swiper.realIndex; // ✅ loop fix

//     wrap.querySelectorAll('.video-slider--dot')
//       .forEach((d, i) =>
//         d.classList.toggle('active', i === active)
//       );
//   };

//   swiper.on('slideChange', update);
//   update();
// }

//   /* --------------- slider init --------------- */
//   function initSliders() {

//     document.querySelectorAll('.video-slider--root')
//       .forEach(root => {

//         const id = root.dataset.sectionId;
//         const cfg = window.videoSlider?.sections?.[id];
//         if (!cfg) return;

//         const swiperEl = root.querySelector('.mySwiper');
//         if (!swiperEl) return;

//         /* ---------- POPUP LOGIC ---------- */
//         const popup = document.getElementById('videoPopup-theme');
//         const popupV = document.getElementById('popupVideo-theme');
//         const prevBtn = popup?.querySelector('.video-popup__nav--prev');
//         const nextBtn = popup?.querySelector('.video-popup__nav--next');

//         if (popup && popupV) {

//           let videoSources = [];
//           let currentVideoIndex = 0;

//           const collectVideoSources = () => {
//             videoSources = Array.from(
//               root.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) video')
//             ).map(v => ({
//               src: v.currentSrc || v.src || v.querySelector('source')?.src
//             })).filter(item => item.src);
//           };

//           const updateNavigationButtons = () => {
//             if (prevBtn) prevBtn.disabled = currentVideoIndex === 0;
//             if (nextBtn) nextBtn.disabled = currentVideoIndex === videoSources.length - 1;
//           };

//           const showVideoInPopup = (index) => {
//             if (index < 0 || index >= videoSources.length) return;

//             currentVideoIndex = index;

//             popupV.src = videoSources[index].src;
//             applySafariSafeVideoAttrs(popupV, { withControls: false, muted: false });
//             popupV.load();

//             updateNavigationButtons();

//             setTimeout(() => popupV.play().catch(() => {}), 100);
//           };

//           root.addEventListener('click', e => {

//             const slide = e.target.closest('.swiper-slide');
//             if (!slide) return;

//             const v = slide.querySelector('video');
//             if (!v) return;

//             collectVideoSources();

//             const clickedSrc =
//               v.currentSrc || v.src || slide.querySelector('source')?.src;

//             currentVideoIndex =
//               videoSources.findIndex(item => item.src === clickedSrc);

//             if (currentVideoIndex === -1) currentVideoIndex = 0;

//             popup.classList.add('active');
//             showVideoInPopup(currentVideoIndex);
//           });

//           if (prevBtn) {
//             prevBtn.addEventListener('click', e => {
//               e.stopPropagation();
//               if (currentVideoIndex > 0) {
//                 showVideoInPopup(currentVideoIndex - 1);
//               }
//             });
//           }

//           if (nextBtn) {
//             nextBtn.addEventListener('click', e => {
//               e.stopPropagation();
//               if (currentVideoIndex < videoSources.length - 1) {
//                 showVideoInPopup(currentVideoIndex + 1);
//               }
//             });
//           }

//           const closePopup = () => {
//             popupV.pause();
//             popupV.currentTime = 0;
//             popup.classList.remove('active');
//           };

//           popup.addEventListener('click', e => {
//             if (e.target === popup ||
//                 e.target.classList.contains('video-popup__close')) {
//               closePopup();
//             }
//           });

//           document.addEventListener('keydown', e => {
//             if (!popup.classList.contains('active')) return;

//             if (e.key === 'Escape') closePopup();
//             else if (e.key === 'ArrowLeft' && currentVideoIndex > 0)
//               showVideoInPopup(currentVideoIndex - 1);
//             else if (e.key === 'ArrowRight' &&
//                      currentVideoIndex < videoSources.length - 1)
//               showVideoInPopup(currentVideoIndex + 1);
//           });
//         }

//         /* ---------- SLIDE COUNT CHECK ---------- */
//         const totalSlides = swiperEl.querySelectorAll(
//           '.swiper-slide:not(.swiper-slide-duplicate)'
//         ).length;

//         const getMaxSlidesPerView = () =>
//           window.innerWidth >= 1280
//             ? cfg.slidesPerViewDesktop
//             : cfg.slidesPerViewMobile;

//         // if (totalSlides <= getMaxSlidesPerView()) {

//         //   swiperEl.classList.add('whout_slider_video');

//         //   const firstVideo =
//         //     swiperEl.querySelector('.swiper-slide video');

//         //   if (firstVideo) {
//         //     applySafariSafeVideoAttrs(firstVideo, { withControls: false, muted: true });
//         //     firstVideo.play().catch(() => {});
//         //   }

//         //   return;
//         // }

//         if (totalSlides <= getMaxSlidesPerView()) {

//   swiperEl.classList.add('whout_slider_video');

//   // ❌ Hide header navigation buttons
//   const prevHeaderBtn = root.querySelector('.video-slider-prev');
//   const nextHeaderBtn = root.querySelector('.video-slider-next');

//   if (prevHeaderBtn) prevHeaderBtn.style.display = 'none';
//   if (nextHeaderBtn) nextHeaderBtn.style.display = 'none';

//   // ❌ Hide dots
//   const dots = root.querySelector('.video-slider--dots');
//   if (dots) dots.style.display = 'none';

//   // ✅ Play first video only
//   const firstVideo = swiperEl.querySelector('.swiper-slide video');

//   if (firstVideo) {
//     applySafariSafeVideoAttrs(firstVideo, { withControls: false, muted: true });
//     firstVideo.play().catch(() => {});
//   }

//   return;
// }

//         /* ---------- INIT CAROUSEL ---------- */
//         const carousel = new window.FoxTheme.Carousel(swiperEl, {
//           slidesPerView: cfg.slidesPerViewMobile,
//           spaceBetween: 10,
//           breakpoints: {
//             1280: {
//               slidesPerView: cfg.slidesPerViewDesktop,
//               spaceBetween: 15
//             }
//           },
//           loop: true,
//           watchSlidesProgress: true,
//           slideToClickedSlide: true,
//         });

//         carousel.init();
//         const swiper = carousel.slider;

//         /* ---------- HEADER NAVIGATION ---------- */
//         const prevHeaderBtn = root.querySelector('.video-slider-prev');
//         const nextHeaderBtn = root.querySelector('.video-slider-next');

//         if (prevHeaderBtn) {
//           prevHeaderBtn.addEventListener('click', () => swiper.slidePrev());
//         }

//         if (nextHeaderBtn) {
//           nextHeaderBtn.addEventListener('click', () => swiper.slideNext());
//         }

//         const updateNavState = () => {
//           if (prevHeaderBtn)
//             prevHeaderBtn.disabled = swiper.isBeginning;

//           if (nextHeaderBtn)
//             nextHeaderBtn.disabled = swiper.isEnd;
//         };

//         swiper.on('slideChange', updateNavState);
//         swiper.on('init', updateNavState);
//         updateNavState();

//         /* ---------- VIDEO AUTO PLAY ---------- */
//         swiper.on('slideChange', () => playActiveVideo(root, swiper));

//         root.querySelectorAll('video').forEach(v => {
//           applySafariSafeVideoAttrs(v, { withControls: false, muted: true });
//           v.addEventListener('ended', () => swiper.slideNext());
//         });

//         swiper.on('init', () =>
//           requestAnimationFrame(() => buildDots(root, swiper))
//         );

//         swiper.on('breakpoint', () =>
//           requestAnimationFrame(() => buildDots(root, swiper))
//         );

//         if (swiper.initialized)
//           requestAnimationFrame(() => buildDots(root, swiper));

//         const kick = () => playActiveVideo(root, swiper);

//         if (swiper.initialized) kick();
//         else swiper.on('init', kick);
//       });
//   }

//   /* --------------- run --------------- */
//   initSliders();

//   if (window.Shopify?.designMode) {
//     document.addEventListener('shopify:section:load', initSliders);
//   }

// })();



(function () {
  const VIDEO_POPUP_OPEN_BODY_CLASS = 'video-pdp-popup-open';

  function setVideoPopupBodyLocked(open) {
    document.body.classList.toggle(VIDEO_POPUP_OPEN_BODY_CLASS, open);
  }

  function applySafariSafeVideoAttrs(video, { withControls = false, muted = true } = {}) {
    if (!video) return;

    video.muted = muted;
    video.loop = !withControls;
    video.controls = withControls;
    // Ensure the DOM attribute matches the property so Safari doesn't render
    // native controls momentarily.
    if (withControls) video.setAttribute('controls', '');
    else video.removeAttribute('controls');
    video.playsInline = true;
    video.disablePictureInPicture = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    video.setAttribute('x-webkit-airplay', 'deny');
    video.setAttribute('disablepictureinpicture', '');
    video.removeAttribute('autopictureinpicture');
  }

  /* --------------- popup: swipe between videos (pointer / touch) --------------- */
  function attachVideoPopupSwipeOnce() {
    const popup = document.getElementById('videoPopup-theme');
    const inner = popup?.querySelector('.video-popup__inner');
    if (!inner || inner.dataset.videoPopupSwipeBound === 'true') return;
    inner.dataset.videoPopupSwipeBound = 'true';

    let startX = 0;
    let startY = 0;
    let activePointerId = null;

    const handleSwipeEnd = (clientX, clientY) => {
      if (!popup.classList.contains('active') || activePointerId === null) return;
      const dx = clientX - startX;
      const dy = clientY - startY;
      const threshold = 50;
      activePointerId = null;
      if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;

      const nav = window.__pdpVideoPopupNav;
      if (!nav) return;
      if (dx > 0) nav.swipePrev();
      else nav.swipeNext();
    };

    inner.addEventListener('pointerdown', (e) => {
      if (!popup.classList.contains('active') || e.button !== 0) return;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
    });
    inner.addEventListener('pointerup', (e) => {
      if (e.pointerId !== activePointerId) return;
      handleSwipeEnd(e.clientX, e.clientY);
    });
    inner.addEventListener('pointercancel', (e) => {
      if (e.pointerId === activePointerId) activePointerId = null;
    });
  }

  /* --------------- helpers --------------- */
  function playActiveVideo(container, swiper) {
    container.querySelectorAll('video').forEach((v) => {
      v.pause();
      applySafariSafeVideoAttrs(v, { withControls: false, muted: true });
    });

    const activeSlide = swiper?.slides?.[swiper.activeIndex];
    if (!activeSlide) return;

    const video = activeSlide.querySelector('video');
    if (!video) return;

    applySafariSafeVideoAttrs(video, { withControls: false, muted: true });
    video.currentTime = 0;
    video.play().catch(() => {});

    container.querySelectorAll('.swiper-slide')
      .forEach(s => s.classList.remove('playing'));

    activeSlide.classList.add('playing');
  }

  function buildDots(root, swiper) {

  let wrap = root.querySelector('.video-slider--dots');

  if (!wrap) {
    wrap = document.createElement('div');
    wrap.className = 'video-slider--dots';
    root.appendChild(wrap);
  }

  wrap.innerHTML = '';

  const realSlides = swiper.slides.filter(
    sl => !sl.classList.contains('swiper-slide-duplicate')
  );

  const currentSlidesPerView = swiper.params.slidesPerView;

  if (realSlides.length <= currentSlidesPerView) {
    wrap.style.display = 'none';
    return;
  }

  wrap.style.display = 'flex';

  const numPages = realSlides.length;

  for (let i = 0; i < numPages; i++) {

    const dot = document.createElement('button');
    dot.className = 'video-slider--dot';

    dot.addEventListener('click', () => {
      swiper.slideToLoop(i, 300); // ✅ loop fix
    });

    wrap.appendChild(dot);
  }

  const update = () => {

    const active = swiper.realIndex; // ✅ loop fix

    wrap.querySelectorAll('.video-slider--dot')
      .forEach((d, i) =>
        d.classList.toggle('active', i === active)
      );
  };

  swiper.on('slideChange', update);
  update();
}

  /* --------------- slider init --------------- */
  function initSliders() {
    attachVideoPopupSwipeOnce();

    document.querySelectorAll('.video-slider--root')
      .forEach(root => {

        const id = root.dataset.sectionId;
        const cfg = window.videoSlider?.sections?.[id];
        if (!cfg) return;

        const swiperEl = root.querySelector('.mySwiper');
        if (!swiperEl) return;

        /* ---------- POPUP LOGIC ---------- */
        const popup = document.getElementById('videoPopup-theme');
        const popupV = document.getElementById('popupVideo-theme');
        const prevBtn = popup?.querySelector('.video-popup__nav--prev');
        const nextBtn = popup?.querySelector('.video-popup__nav--next');

        if (popup && popupV) {

          let videoSources = [];
          let currentVideoIndex = 0;

          const collectVideoSources = () => {
            videoSources = Array.from(
              root.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) video')
            ).map(v => ({
              src: v.currentSrc || v.src || v.querySelector('source')?.src
            })).filter(item => item.src);
          };

          const updateNavigationButtons = () => {
            if (prevBtn) prevBtn.disabled = currentVideoIndex === 0;
            if (nextBtn) nextBtn.disabled = currentVideoIndex === videoSources.length - 1;
          };

          const showVideoInPopup = (index) => {
            if (index < 0 || index >= videoSources.length) return;

            currentVideoIndex = index;

            popupV.src = videoSources[index].src;
            applySafariSafeVideoAttrs(popupV, { withControls: false, muted: false });
            popupV.load();

            updateNavigationButtons();

            setTimeout(() => popupV.play().catch(() => {}), 100);
          };

          root.addEventListener('click', e => {

            const slide = e.target.closest('.swiper-slide');
            if (!slide) return;

            const v = slide.querySelector('video');
            if (!v) return;

            collectVideoSources();

            const clickedSrc =
              v.currentSrc || v.src || slide.querySelector('source')?.src;

            currentVideoIndex =
              videoSources.findIndex(item => item.src === clickedSrc);

            if (currentVideoIndex === -1) currentVideoIndex = 0;

            window.__pdpVideoPopupNav = {
              swipePrev: () => {
                if (currentVideoIndex > 0) showVideoInPopup(currentVideoIndex - 1);
              },
              swipeNext: () => {
                if (currentVideoIndex < videoSources.length - 1) {
                  showVideoInPopup(currentVideoIndex + 1);
                }
              },
            };

            popup.classList.add('active');
            setVideoPopupBodyLocked(true);
            showVideoInPopup(currentVideoIndex);
          });

          if (prevBtn) {
            prevBtn.addEventListener('click', e => {
              e.stopPropagation();
              if (currentVideoIndex > 0) {
                showVideoInPopup(currentVideoIndex - 1);
              }
            });
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', e => {
              e.stopPropagation();
              if (currentVideoIndex < videoSources.length - 1) {
                showVideoInPopup(currentVideoIndex + 1);
              }
            });
          }

          const closePopup = () => {
            popupV.pause();
            popupV.currentTime = 0;
            popup.classList.remove('active');
            setVideoPopupBodyLocked(false);
          };

          popup.addEventListener('click', e => {
            if (e.target === popup ||
                e.target.classList.contains('video-popup__close')) {
              closePopup();
            }
          });

          document.addEventListener('keydown', e => {
            if (!popup.classList.contains('active')) return;

            if (e.key === 'Escape') closePopup();
            else if (e.key === 'ArrowLeft' && currentVideoIndex > 0)
              showVideoInPopup(currentVideoIndex - 1);
            else if (e.key === 'ArrowRight' &&
                     currentVideoIndex < videoSources.length - 1)
              showVideoInPopup(currentVideoIndex + 1);
          });
        }

        /* ---------- SLIDE COUNT CHECK ---------- */
        const totalSlides = swiperEl.querySelectorAll(
          '.swiper-slide:not(.swiper-slide-duplicate)'
        ).length;

        const getMaxSlidesPerView = () =>
          window.innerWidth >= 1280
            ? cfg.slidesPerViewDesktop
            : cfg.slidesPerViewMobile;

        // if (totalSlides <= getMaxSlidesPerView()) {

        //   swiperEl.classList.add('whout_slider_video');

        //   const firstVideo =
        //     swiperEl.querySelector('.swiper-slide video');

        //   if (firstVideo) {
        //     applySafariSafeVideoAttrs(firstVideo, { withControls: false, muted: true });
        //     firstVideo.play().catch(() => {});
        //   }

        //   return;
        // }

        if (totalSlides <= getMaxSlidesPerView()) {

  swiperEl.classList.add('whout_slider_video');

  // ❌ Hide header navigation buttons
  const prevHeaderBtn = root.querySelector('.video-slider-prev');
  const nextHeaderBtn = root.querySelector('.video-slider-next');

  if (prevHeaderBtn) prevHeaderBtn.style.display = 'none';
  if (nextHeaderBtn) nextHeaderBtn.style.display = 'none';

  // ❌ Hide dots
  const dots = root.querySelector('.video-slider--dots');
  if (dots) dots.style.display = 'none';

  // ✅ Play first video only
  const firstVideo = swiperEl.querySelector('.swiper-slide video');

  if (firstVideo) {
    applySafariSafeVideoAttrs(firstVideo, { withControls: false, muted: true });
    firstVideo.play().catch(() => {});
  }

  return;
}

        /* ---------- INIT CAROUSEL ---------- */
        const carousel = new window.FoxTheme.Carousel(swiperEl, {
          slidesPerView: cfg.slidesPerViewMobile,
          spaceBetween: 10,
          breakpoints: {
            1280: {
              slidesPerView: cfg.slidesPerViewDesktop,
              spaceBetween: 15
            }
          },
          loop: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });

        carousel.init();
        const swiper = carousel.slider;

        /* ---------- HEADER NAVIGATION ---------- */
        const prevHeaderBtn = root.querySelector('.video-slider-prev');
        const nextHeaderBtn = root.querySelector('.video-slider-next');

        if (prevHeaderBtn) {
          prevHeaderBtn.addEventListener('click', () => swiper.slidePrev());
        }

        if (nextHeaderBtn) {
          nextHeaderBtn.addEventListener('click', () => swiper.slideNext());
        }

        const updateNavState = () => {
          if (prevHeaderBtn)
            prevHeaderBtn.disabled = swiper.isBeginning;

          if (nextHeaderBtn)
            nextHeaderBtn.disabled = swiper.isEnd;
        };

        swiper.on('slideChange', updateNavState);
        swiper.on('init', updateNavState);
        updateNavState();

        /* ---------- VIDEO AUTO PLAY ---------- */
        swiper.on('slideChange', () => playActiveVideo(root, swiper));

        root.querySelectorAll('video').forEach(v => {
          applySafariSafeVideoAttrs(v, { withControls: false, muted: true });
          v.addEventListener('ended', () => swiper.slideNext());
        });

        swiper.on('init', () =>
          requestAnimationFrame(() => buildDots(root, swiper))
        );

        swiper.on('breakpoint', () =>
          requestAnimationFrame(() => buildDots(root, swiper))
        );

        if (swiper.initialized)
          requestAnimationFrame(() => buildDots(root, swiper));

        const kick = () => playActiveVideo(root, swiper);

        if (swiper.initialized) kick();
        else swiper.on('init', kick);
      });
  }

  /* --------------- run --------------- */
  initSliders();

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', initSliders);
  }

})();
